module.exports = __webpack_public_path__ + "img/icono-generico.ccbb6136.png";